module.exports = __webpack_public_path__ + "img/title-2.a7e905f4.png";